import { render, staticRenderFns } from "./Acerca.vue?vue&type=template&id=5632b070&lang=pug&"
import script from "./Acerca.vue?vue&type=script&lang=js&"
export * from "./Acerca.vue?vue&type=script&lang=js&"
import style0 from "./Acerca.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VFlex,VLayout,VSkeletonLoader})
